module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms11-2c3f17b34a8c19b5078e7ec6c81657dc.jpg";